// extracted by mini-css-extract-plugin
export default {"panel-header":"PanelHeader_panel-header__dUSxs","panelHeader":"PanelHeader_panel-header__dUSxs"};